module.exports = __webpack_public_path__ + "videos/gradient-map_en.891d690.mp4";